<script lang="ts">
  import { aiFeaturesStore } from '$lib/stores/aiFeatures'

  /**
   * SplitResizeController: Handles split panel resizing
   * Single Responsibility: Manage drag-to-resize functionality for split panels
   */

  interface Props {
    splitRatio: number
    isDragging: boolean
  }

  let { 
    splitRatio = $bindable(50),
    isDragging = $bindable(false)
  }: Props = $props()

  // Handle splitter drag
  export function startResize(e: MouseEvent) {
    isDragging = true
    e.preventDefault()
    
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return
      
      const container = document.querySelector('.split-editor')
      if (!container) return
      
      const rect = container.getBoundingClientRect()
      const x = e.clientX - rect.left
      const percentage = (x / rect.width) * 100
      
      splitRatio = Math.max(20, Math.min(80, percentage))
      aiFeaturesStore.setSplitRatio(splitRatio)
    }
    
    const handleMouseUp = () => {
      isDragging = false
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
    
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
  }
</script>